<p-card>
    <div class="">
        <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
                <div>
                    <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle"
                        (click)="createUnitsOfMeasure()" size="small" pTooltip="Create Unit of Measure"></p-button>
                </div>
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                            (keyup.enter)="searchUOM()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchUOM()" [ngStyle]="{ height: '35px' }" [raised]="true" class="ml-2"
                        [size]="'small'" severity="info"></p-button>
                </div>
                <p-button *ngIf="selectedUnitsOfMeasurement && selectedUnitsOfMeasurement.length == 1" label="Edit"
                    class="ml-2" icon="pi pi-pencil" (click)="editUnitsOfMeasure()" size="small"
                    severity="secondary"></p-button>
                <p-button *ngIf="selectedUnitsOfMeasurement && selectedUnitsOfMeasurement.length > 0" label="Delete"
                    class="ml-2" icon="pi pi-trash" (click)="deleteUnitsOfMeasure()" size="small"
                    severity="danger"></p-button>
            </div>
                        <h2 class="page-title-center">Unit of Measure List</h2>

            <div class="flex">
                <div class="flex align-items-center">
                    <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                        severity="info"></p-button>
                </div>
            </div>
        </div>

         <!--code added here-->
        <p-table #dt1 [value]="result.unitsofMeasures"  [scrollable]="false"  scrollHeight="650px" styleClass="p-datatable-sm"
        responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"  [rowsPerPageOptions]="[10,15,20]" [rowHover]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onPage)="unitsOfMeasures($event)"
            [globalFilterFields]="['unitsofMeasureCode']" [(selection)]="selectedUnitsOfMeasurement">
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>UOM Code</th>
                    <th>Units of Measure</th>
                    <th>UOM Description</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-UnitsOfMeasure>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="UnitsOfMeasure"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editUnitsOfMeasure(UnitsOfMeasure.unitsofMeasureId)">{{UnitsOfMeasure.unitsofMeasureCode}}</td>
                    <td>{{UnitsOfMeasure.unitsofMeasure}}</td>
                    <td>{{UnitsOfMeasure.unitsofMeasureDescription}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
<p-confirmDialog></p-confirmDialog>
